<template>
  <div v-if="renderComponent" class="d-block w-100">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-layout
      row
      ma-0
      justify-space-between
    >
      <!-- <v-btn
        v-if="changeFirm"
        class="mr-6 mb-3"
        fab
        elevation="0"
        max-width="100"
        max-height="100"
        width="100"
        height="100"
        @click.stop="dialog = true"
      >
        <v-img
          class="rounded"
          :src="profileItems.img"
          aspect-ratio="1"
          max-width="100"
          max-height="100"
          width="100"
          height="100"
        ></v-img>
      </v-btn> -->
      <!-- else just show image -->
      <v-img
        class="rounded mr-6 mb-3"
        :src="img"
        aspect-ratio="1"
        max-width="100"
        max-height="100"
        width="100"
        height="100"
      ></v-img>

      <v-layout
        justify-center
        column
      >
        <h2 class="mb-3" v-html="name.value === '' ? $t('profile-card.noname') : name.value"></h2>
        <!-- <h2 class="mb-3" v-html="san1(name.value)"></h2> -->
        <small class="mb-2" v-html="`Email : ${email.value ===  '' ? $t('profile-card.noemail') : email.value}`"></small>
        <small class="mb-3" v-html="`Tel. : ${tel.value === '' ? $t('profile-card.notel') : tel.value}`"></small>
        <small class="mb-3" v-html="`${$t('profile-card.password')} : ************`"></small>
        <v-layout
          justify-end
          align-center
          row
          ma-0
        >
          <button class="link" @click="dialog = true">
            {{ $t("profile-card.btn") }}
            <v-icon color="primary" class="ml-1" size="12">icon-edit</v-icon>
          </button>
        </v-layout>
      </v-layout>
    </v-layout>

   <!-- Dialog : edit profile -->
   <v-dialog
      v-model="dialog"
      max-width="650"
   >
      <v-card class="ma-0">
        <v-card-title class="headline mb-5">{{ $t('profile-card.dialog.title') }} - {{ login !== 'Login name' ? login : 'Login name' }}</v-card-title>

        <v-card-text>
          {{ $t('profile-card.dialog.warning') }}
        </v-card-text>

        <v-card-text>
          <v-text-field
            v-model="name.edit"
            :rules="[rules.empty]"
            :label="$t('profile-card.dialog.label-1')"
            outlined
            class="mb-6"
          ></v-text-field>
          <v-text-field
            v-model="email.edit"
            :label="$t('profile-card.dialog.label-2')"
            outlined
            :rules="[rules.email]"
            class="mb-6"
          ></v-text-field>
          <v-text-field
            v-model="tel.edit"
            :label="$t('profile-card.dialog.label-3')"
            outlined
            :rules="[rules.number]"
            class="mb-6"
          ></v-text-field>
          <v-text-field
            v-model="password.edit"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            :rules="[rules.lower, rules.upper, rules.number, rules.digit, rules.min(password.edit, 7)]"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('profile-card.dialog.label-4')"
            hint="At least 7 characters"
            counter
            required
            aria-required
            @click:append="showPassword = !showPassword"
            outlined
            class="mandatory mb-6"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            text
            color="error"
            @click="dialog = false"
          >
            {{ $t('profile-card.dialog.btn-1') }}
          </v-btn>
          <v-btn
            outlined
            rounded
            color="primary"
            @click="editMyProfile"
          >
            {{ $t('profile-card.dialog.btn-2') }}
          </v-btn>
        </v-card-actions>
      </v-card>
   </v-dialog><!-- Dialog : edit profile -->
  </div>
</template>

<script>
import { setPasswordOrEmail } from '@/js/auth/editProfile'
import { userVar } from '@/js/auth/userVar'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    HTTPresponse: HTTPresponse
  },
  data () {
    return {
      renderComponent: true,
      dialog: false,

      // test: 'svrzevbeb',

      login: 'Login name',
      name: { value: this.$t('profile-card.noname'), edit: '' },
      email: { value: this.$t('profile-card.noemail'), edit: '' },
      tel: { value: this.$t('profile-card.notel'), edit: '' },
      showPassword: false,
      password: { value: '************', edit: '' },
      img: `${require('@/assets/images/profile-man.svg')}`,

      rules: {
        empty: value => {
          if (value === '') return true
          const reg = /^\s+$/
          if (reg.test(value) === true) return this.$t('rules-field.empty')
          else return true
        },
        email: value => {
          if (value === '') return true
          const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return reg.test(value) || this.$t('rules-field.email')
        },
        digit: value => {
          if (value === '') return true
          // const reg = /\d/ // should contain at least one digit
          const reg = /[\W_]+/ // should contain at least one digit
          return reg.test(value) || this.$t('rules-field.digit')
        },
        number: value => {
          if (value === '') return true
          const reg = /[0-9]/ // should contain at least one number
          return reg.test(value) || this.$t('rules-field.number')
        },
        lower: value => {
          if (value === '') return true
          const reg = /[a-z]/ // should contain at least one lower case
          return reg.test(value) || this.$t('rules-field.lower')
        },
        upper: value => {
          if (value === '') return true
          const reg = /[A-Z]/ // should contain at least one upper case
          return reg.test(value) || this.$t('rules-field.upper')
        },
        min: (value, min) => {
          if (value === '') return true
          else if (value.length >= 7) return true
          else return this.$t('rules-field.min', 1, {n: min})
        }
      },

      httpalert: false
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    this.updateProfile()
  },

  methods: {
    editMyProfile () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      // if password set change it
      if (this.password.edit !== '') {
        const params = {
          password: this.password.edit,
          key: this.$store.state.auth.token
        }
        setPasswordOrEmail(params)
          .then(() => {})
          .catch(() => {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          })
      }
      // if email change set the new email
      if (this.email.edit !== '') {
        const params = {
          email: this.email.edit,
          key: this.$store.state.auth.token
        }
        setPasswordOrEmail(params)
          .then(() => {})
          .catch(() => {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          })
      }

      if (this.name.edit !== '' && this.name.edit !== this.name.value) {
        // Set user name if it change
        const paramsName = {
          options: 'set',
          name: 'name',
          value: this.name.edit,
          key: this.$store.state.auth.token
        }
        userVar(paramsName)
          .then(() => {})
          .catch(() => {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          })
      }

      if (this.email.edit !== '' && this.email.edit !== this.email.value) {
        // Set user name if it change
        const paramsEmail = {
          options: 'set',
          name: 'email',
          value: this.email.edit,
          key: this.$store.state.auth.token
        }
        userVar(paramsEmail)
          .then(() => {})
          .catch(() => {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          })
      }
      if (this.tel.edit !== '' && this.tel.edit !== this.tel.value) {
        // Set user name if it change
        const paramsTel = {
          options: 'set',
          name: 'phone',
          value: this.tel.edit,
          key: this.$store.state.auth.token
        }
        userVar(paramsTel)
          .then(() => {})
          .catch(() => {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          })
      }

      this.dialog = false
      this.updateProfile()
    },

    async updateProfile() {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      // Set login name if exist
      const paramsLogin = { options: 'get', name: 'login', key: this.$store.state.auth.token }
      await userVar(paramsLogin)
        .then(response => {
          if (response.data !== '') this.login = response.data
        }).catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })

      // Set user name if exist
      const paramsName = { options: 'get', name: 'name', key: this.$store.state.auth.token }
      await userVar(paramsName)
        .then(response => {
          if (response.data !== '') {
            this.name.value = response.data
            this.name.edit = response.data
          }
        }).catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })

      // Set user email if exist
      const paramsEmail = { options: 'get', name: 'email', key: this.$store.state.auth.token }
      await userVar(paramsEmail)
        .then(response => {
          if (response.data !== '') {
            this.email.value = response.data
            this.email.edit = response.data
          }
        }).catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })

      // Set user email if exist
      const paramsTel = { options: 'get', name: 'phone', key: this.$store.state.auth.token }
      await userVar(paramsTel)
        .then(response => {
          if (response.data !== '') {
            this.tel.value = response.data
            this.tel.edit = response.data
          }
        }).catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
